<script>
	export let active;
	import Template from '../components/Template.svelte';
</script>
<Template active={active}>
	<h2>About!</h2>
</Template>